import { Box } from '@chakra-ui/react';

export default function TitleSingleBlog({ created, categoryName, title }) {
  return (
    <div>
      <Box m="20px 0">
        <Box as={'h1'} fontSize={{ base: '24', md: '28px', lg: '32px' }} fontWeight="bold" textAlign="center">
          {title}
        </Box>
        <Box as={'p'} fontSize={{ base: '16', md: '20px', lg: '22px' }} textAlign="center">
          {created}
        </Box>
      </Box>
    </div>
  );
}
